// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"43727749","128":"38849095","150":"55ce1af4","592":"ee7bcd77"}[chunkId] + ".chunk.js";
};